import Reflux from "reflux";
import { singletonActions } from "logic/singleton";
const WatchlistActions = singletonActions(
  "enterprise.Watchlist",
  () => Reflux.createActions({
    delete: { asyncResult: true },
    update: { asyncResult: true }
  })
);
export default WatchlistActions;
